import { Injectable } from '@angular/core';

import { NOTIFICATION_SOUND_URL } from './order-notification-config';

@Injectable({ providedIn: 'root' })
export class NotificationSoundService {
  private notificationAudio: HTMLAudioElement | null = null;

  warmup(): void {
    const audio = this.getNotificationAudio();
    if (!audio) return;
    audio.load();
    void audio
      .play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
      })
      .catch(() => undefined);
  }

  play(): void {
    if (typeof window === 'undefined') return;
    const audio = this.getNotificationAudio();
    if (!audio) return;
    audio.currentTime = 0;
    void audio.play().catch(() => undefined);
  }

  private getNotificationAudio(): HTMLAudioElement | null {
    if (this.notificationAudio) return this.notificationAudio;
    try {
      this.notificationAudio = new Audio(NOTIFICATION_SOUND_URL);
      this.notificationAudio.preload = 'auto';
      return this.notificationAudio;
    } catch {
      return null;
    }
  }
}
